export function downloadCsv(filename: string, header: string[], rows: string[][]): void {
  const lines = [header.join(','), ...rows.map((row) => row.join(','))];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
